<!--Access denied Component - 1.0.0
    Created : 20-FEB-2020
    Created By : SPR/860
    Modified : 20-FEB-2020
    Dependencies: VUE JS
    Use : Access denied ui. -->
<template>
    <div>
        <v-container fluid class="access-denied">
            <v-toolbar-title>
                <v-btn color="error" fab small dark>
                    <v-icon>mdi-lock</v-icon>
                </v-btn>
                {{messages.accessDenied}}
            </v-toolbar-title>
            <v-toolbar-title class="content">{{messages.accessDenyText}} <b>{{title}}</b></v-toolbar-title>
        </v-container>
    </div>
</template>

<script>
    export default {
        data() {
            return this.$store.state[this.$options.parent.fileName || this.$options.parent.$parent.fileName];
        }
    }
</script>
